import { useState, useEffect } from 'react';
import * as storage from '../browserStorage';

const STORAGE_KEY = 'HEADLESS_ORDER_TYPE';
let globalChecked = null;
let listeners = [];

// Initialize from localStorage on first load
if (globalChecked === null && typeof window !== 'undefined') {
    const storedValue = storage.getItem(STORAGE_KEY);
    if (storedValue) {
        globalChecked = storedValue;
    }
}

export const useSharedOrderType = (forcedInitialValue = null) => {
    const [checked, setChecked] = useState(() => {
        // If there's a forced initial value, use it
        if (forcedInitialValue) {
            globalChecked = forcedInitialValue;
            storage.setItem(STORAGE_KEY, forcedInitialValue);
            return forcedInitialValue;
        }
        
        // Initialize from localStorage if globalChecked is still null
        if (globalChecked === null && typeof window !== 'undefined') {
            const storedValue = storage.getItem(STORAGE_KEY);
            if (storedValue) {
                globalChecked = storedValue;
                return storedValue;
            }
        }
        return globalChecked;
    });

    useEffect(() => {
        const listener = (newValue) => {
            setChecked(newValue);
        };

        listeners.push(listener);

        // If there's a global value, update the local state
        if (globalChecked !== null) {
            setChecked(globalChecked);
        }

        return () => {
            listeners = listeners.filter(l => l !== listener);
        };
    }, []);

    const setGlobalChecked = (newValue) => {
        globalChecked = newValue;

        // Persist to localStorage
        if (newValue) {
            storage.setItem(STORAGE_KEY, newValue);
        } else {
            storage.removeItem(STORAGE_KEY);
        }

        // Notify all listeners
        listeners.forEach(listener => listener(newValue));
    };

    return [checked, setGlobalChecked];
};
